import { IntegrationChannelType } from 'generated/graphql';

interface GetIsIntegrationEditOptionalOptions {
  channelType: IntegrationChannelType;
}

export const getIsIntegrationEditOptional = ({
  channelType,
}: GetIsIntegrationEditOptionalOptions) => {
  switch (channelType) {
    case IntegrationChannelType.Playstore:
      return true;
    default:
      return false;
  }
};
